import React from "react";
import { Menu, MenuItem, Typography, Box } from "@mui/material";

interface ColorMenuProps {
  anchorEl: HTMLElement | null;
  open: boolean;
  onClose: () => void;
  colors: any[];
  onColorSelect: (colorId: string) => void;
  getColorHex: (colorId: string) => string;
}

const ColorMenu: React.FC<ColorMenuProps> = ({
  anchorEl,
  open,
  onClose,
  colors,
  onColorSelect,
  getColorHex,
}) => {
  return (
    <Menu open={open} anchorEl={anchorEl} onClose={onClose}>
      <Typography sx={{ p: 1, fontWeight: "bold" }}>Pick a color:</Typography>
      {colors.map((color) => (
        <MenuItem
          key={color.id}
          onClick={() => {
            onColorSelect(color.id);
          }}
          sx={{ justifyContent: "space-between" }}
        >
          <span>{color.displayName}</span>
          <Box
            sx={{
              ml: 2,
              width: 16,
              height: 16,
              border: "1px solid #000",
              backgroundColor: getColorHex(color.id),
            }}
          />
        </MenuItem>
      ))}
    </Menu>
  );
};

export default ColorMenu;
